import React, { useState } from 'react';
import { MedalPodium } from "../MedalPodium";
import { MedalTable } from "../MedalTable";
import "./index.css";

export const Landing = () => {
  const [defaultSort, setDefaultSort] = useState('gold');
  
  const copyToClipboard = (podium = false, type = "na", language = "na", size = "na", defaultSort = "gold") => {
    if (!podium) {
      navigator.clipboard.writeText(
        `<iframe
        src="https://graphics.thecanadianpress.com/paris2024/#/table/${type}/${language}/${size}/${defaultSort}"
        title="Medals"
        style="height: 100%; width: 100%"
        frameborder="0"
        scrolling="no"
      ></iframe>`
      );
      return;
    }
    navigator.clipboard.writeText(
      `<iframe
        src="https://graphics.thecanadianpress.com/paris2024/#/podium/${language}"
        title="Canada Medals"
        style="height: 100%; width: 100%"
        frameborder="0"
        scrolling="no"
      ></iframe>`
    );
    return;
  };

  const renderIframeInputAndCopyButton = (podium, type, language, size, defaultSort) => {
    const iframeSrc = podium
      ? `https://graphics.thecanadianpress.com/paris2024/#/podium/${language}`
      : `https://graphics.thecanadianpress.com/paris2024/#/table/${type}/${language}/${size}/${defaultSort}`;

    const iframeCode = `<iframe src="${iframeSrc}" title="Medals" style="height: 100%; width: 100%" frameborder="0" scrolling="no"></iframe>`;

    return (
      <>
        <input
          className="IframeLink"
          readOnly
          value={iframeCode}
        />
        <button
          className="ClipboardButton"
          onClick={() => copyToClipboard(podium, type, language, size, defaultSort)}
        >
          Copy Code
        </button>
      </>
    );
  };

  return (
    <div>
      <div className='settingsRow'>
        <label>
          Default Sort:
        </label>
        <select value={defaultSort} onChange={e => setDefaultSort(e.target.value)}>
          <option value="gold">Gold</option>
          <option value="total">Total</option>
        </select>
      </div>
      <div className="LandingContainer">
        <div className="Column">
          <h1>English Tables</h1>
          <h2>Long</h2>
          <MedalTable language="en" defaultSort={defaultSort} type="standard" size="long" tableWidth={300} tableHeight={500} />
          {renderIframeInputAndCopyButton(false, "na", "en", "long", defaultSort)}
          <h2>Short</h2>
          <MedalTable language="en" defaultSort={defaultSort} size="short" tableWidth={300} tableHeight={300} />
          {renderIframeInputAndCopyButton(false, "standard", "en", "short", defaultSort)}
          <h2>Canada Top Long</h2>
          <MedalTable language="en" defaultSort={defaultSort} type="canada" size="long" tableWidth={300} tableHeight={500} />
          {renderIframeInputAndCopyButton(false, "canada", "en", "long", defaultSort)}
          <h2>Canada Top Short</h2>
          <MedalTable language="en" defaultSort={defaultSort} type="canada" size="short" tableWidth={300} tableHeight={280} />
          {renderIframeInputAndCopyButton(false, "canada", "en", "short", defaultSort)}
          <h2>Podium</h2>
          <MedalPodium language="en" tableWidth={286} />
          {renderIframeInputAndCopyButton(true, "standard", "en", "short", defaultSort)}
        </div>
        <div className="Column">
          <h1>French Tables</h1>
          <h2>Long</h2>
          <MedalTable defaultSort={defaultSort} type="standard" language="fr" size="long" tableWidth={300} tableHeight={500} />
          {renderIframeInputAndCopyButton(false, "standard", "fr", "long", defaultSort)}
          <h2>Short</h2>
          <MedalTable defaultSort={defaultSort} type="standard" size="short" language="fr" tableWidth={300} tableHeight={300} />
          {renderIframeInputAndCopyButton(false, "standard", "fr", "short", defaultSort)}
          <h2>Canada Top Long</h2>
          <MedalTable defaultSort={defaultSort} type="canada" language="fr" size="long" tableWidth={300} tableHeight={500} />
          {renderIframeInputAndCopyButton(false, "canada", "fr", "long", defaultSort)}
          <h2>Canada Top Short</h2>
          <MedalTable defaultSort={defaultSort} type="canada" size="short" language="fr" tableWidth={300} tableHeight={280} />
          {renderIframeInputAndCopyButton(false, "canada", "fr", "short", defaultSort)}
          <h2>Podium</h2>
          <MedalPodium language="fr" tableWidth={350} />
          {renderIframeInputAndCopyButton(true, "standard", "fr", "short", defaultSort)}
        </div>
      </div>
    </div>
  );
};
